@if (display) {
  <p-dialog [styleClass]="'insurance-form-dialog ' + (authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : ''))" [style]="{'width': '42vw'}" header="{{title | uppercase}}" [(visible)]="display" showEffect="fade" [modal]="true"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div #errorContainer>
        @if (errorMessages.length !== 0) {
          <div>
            @for (error of errorMessages; track error) {
              <div>
                <div class='alert alert-warning' role='alert'>{{error}}</div>
              </div>
            }
          </div>
        }
      </div>
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="policyNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    <strong> {{'tableManagement.insurance.policyNumber' | translate}} (*)</strong>
                </label>
          <div class="p-0"></div>
          <input type="text" id="policyNumber" class="form-control custom-input" [(ngModel)]="entity.policyNumber"
            [disabled]="!formManipulation">
        </div>
        <div class="col-sm-6">
          <label for="insurance-provider" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>{{'tableManagement.insurance.insurer' |
                    translate}} (*)</strong></label>
          <div class="p-0"></div>
          <p-select [options]='providerList' [(ngModel)]='entity.provider'
            placeholder="{{'general.select' | translate}} {{'tableManagement.insurance.insurer' | translate}}"
            dataKey='id' optionLabel='name' [style]="{'width':'100%'}" appendTo='body' [filter]="true"
            filterBy="name" (onChange)="onChangeProvider($event)" (onFilter)="onFilterProvider($event)"
            [disabled]="!formManipulation || saving">
          </p-select>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="agent" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.insurance.agent' | translate}}
                </label>
          <div class="p-0"></div>
          <input  i18n-placeholder placeholder="{{'general.unassigned' | translate}}" type="text" id="agent" class="form-control custom-input" [(ngModel)]="entity.agent"
            [disabled]="!formManipulation || saving">
        </div>
        @if (!vehicleId) {
          <div class="col-sm-6">
            <label for="insurance-vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{'tableManagement.vehicle.vehicle' |
                    translate}}</label>
            <div class="p-0"></div>
            <p-select [options]='vehicleList' [(ngModel)]='entity.vehicle'
              placeholder="{{'general.select' | translate}} {{'tableManagement.vehicle.vehicle' | translate}}"
              dataKey='id' optionLabel='name' [style]="{'width':'100%'}" appendTo='body' [filter]="true"
              filterBy="name" (onChange)="onChangeVehicle($event)" (onFilter)="onFilterVehicle($event)"
              [disabled]="!formManipulation || saving">
            </p-select>
          </div>
        }
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="cost" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.insurance.cost' | translate}}
                </label>
          <div class="p-0"></div>
          <div class="input-wrapper">
            @if (canSeeCosts) {
              <p-inputNumber [style]="{width: '100%'}" [inputStyle]="{width: '100%'}" [showButtons]="false" [(ngModel)]="entity.cost" mode="decimal" locale="es-ES"
              (onKeyDown)="onKeyDownDecimal($event)" [disabled]="!formManipulation || saving"></p-inputNumber>
            }
            @if (!canSeeCosts) {
              <p-inputNumber [style]="{width: '100%'}" [inputStyle]="{width: '100%'}" [showButtons]="false" [ngModel]="" mode="decimal" locale="es-ES"
              (onKeyDown)="onKeyDownDecimal($event)" [disabled]="!formManipulation || saving"></p-inputNumber>
            }
            <span class="input-symbol">€</span>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="fleetCost" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.insurance.fleetCost' | translate}}
                </label>
          <div class="p-0"></div>
          <div class="input-wrapper">
            @if (canSeeCosts) {
              <p-inputNumber [style]="{width: '100%'}" [inputStyle]="{width: '100%'}" [showButtons]="false" [(ngModel)]="entity.fleetCost" mode="decimal" locale="es-ES"
              (onKeyDown)="onKeyDownDecimal($event)" [disabled]="!formManipulation || saving"></p-inputNumber>
            }
            @if (!canSeeCosts) {
              <p-inputNumber [style]="{width: '100%'}" [inputStyle]="{width: '100%'}" [showButtons]="false" [ngModel]="''" mode="decimal" locale="es-ES"
              (onKeyDown)="onKeyDownDecimal($event)" [disabled]="!formManipulation || saving"></p-inputNumber>
            }
            <span class="input-symbol">€</span>
          </div>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="startDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                <strong> {{'general.startDate' | translate}} (*)</strong>
                </label>
          <div class="p-0"></div>
          <p-datepicker [(ngModel)]='startDateInsurance' [showTime]='false' [style]="{'width':'100%'}"
            showIcon='true' appendTo='body' [firstDayOfWeek]="1" dateFormat='{{i18n.dateFormat}}'
          [disabled]="!formManipulation || saving"></p-datepicker>
        </div>
        <div class="col-sm-6">
          <label for="endDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                <strong> {{'general.endDate' | translate}} (*)</strong>
                </label>
          <div class="p-0"></div>
          <p-datepicker [(ngModel)]='endDateInsurance' [showTime]='false' [style]="{'width':'100%'}"
            showIcon='true' appendTo='body' dateFormat='{{i18n.dateFormat}}'
          [disabled]="!formManipulation || saving"></p-datepicker>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="insurance-type" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>{{'tableManagement.insurance.insuranceType' |
                    translate}} (*)</strong></label>
          <div class="p-0"></div>
          <p-select [options]='insuranceTypeList' [(ngModel)]='entity.insuranceType'
            placeholder="{{'general.select' | translate}} {{'tableManagement.insurance.insuranceType' | translate}}"
            dataKey='id' optionLabel='name' [style]="{'width':'100%'}" appendTo='body' [filter]="true"
            filterBy="name" (onChange)="onChangeInsuranceType($event)"
            (onFilter)="onFilterInsuranceType($event)" [disabled]="!formManipulation || saving">
          </p-select>
        </div>
        <div class="col-sm-6">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.active' | translate }}
                </label>
          <div class="p-0"></div>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
            type="checkbox" [(ngModel)]="active" [disabled]="!formManipulation || saving">
        </div>
      </div>
      <!-- OBSERVATIONS -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="observations" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{'general.observations' |
                    translate}}</label>
          <textarea rows="2" pInputTextarea [pTooltip]="entity.observations" tooltipPosition="top"
            [(ngModel)]="entity.observations" class="observations" fitContent="true" [style]="{'width':'100%'}"
          [disabled]="!formManipulation || saving"></textarea>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-6">
          <label for="cancellationDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                  {{'tableManagement.financing.cancelationDate' | translate}}
              </label>
          <div class="p-0"></div>
          <p-datepicker [(ngModel)]='disabledDateInsurance' [showTime]='false' [style]="{'width':'100%'}"
            showIcon='true' appendTo='body' [firstDayOfWeek]="1" dateFormat='{{i18n.dateFormat}}'
          [disabled]="!formManipulation || saving"></p-datepicker>
        </div>
      </div>
      <div class="p-2"></div>
      <!-- COMPONENT -->
      @if (!isNew) {
        <p-panel header="{{ 'tableManagement.insurance.insuranceComponentTitle' | translate }}"
          [toggleable]="true" class='w-100' [collapsed]="true">
          <app-insurance-component-list [insurance]="entity"></app-insurance-component-list>
        </p-panel>
      }
      <!-- taula de documents -->
      @if (!isNew) {
        <div class="row mt-3">
          <app-doc-table type="insurance" [entity]="entity" [nested]="true" [ids]="ids" (return)="refresh()">
          </app-doc-table>
        </div>
      }
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation || saving" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation || saving" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!entity.disabled)" i18n>
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}

<!-- CONFIRM SAVE EVENT DIALOG -->
<p-confirmDialog key="insurance-form" appendTo="body" #missingFieldsDialog [header]=" 'confirm.critic' | translate "
  icon='pi pi-exclamation-triangle'>
  <ng-template pTemplate="footer">
    <button (click)="missingFieldsDialog.onAccept()" class="custom-button">
      OK
    </button>
  </ng-template>
</p-confirmDialog>